// 🔒
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import HeroSection from "../components/HeroSection";
// import FeaturesSection from "../components/FeaturesSection";
import TrainerBenefitsSection from "../components/TrainerBenefitsSection";
import TrainerJoinSection from "../components/TrainerJoinSection";
import TrainersSection from "../components/TrainersSection";
import ProgramsSection from "../components/ProgramsSection";
import DownloadCTASection from "../components/DownloadCTASection";
import TestimonialsSection from "../components/TestimonialsSection";

export default function LandingPage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const targetId = params.get("scrollTo");

    if (!targetId) return;

    const navbar = document.querySelector(".navbar");
    const navbarHeight = navbar ? navbar.offsetHeight : 0;
    const offset = 16;

    let attempts = 0;
    const maxAttempts = 30;
    let rafId = 0;
    let timeoutId = 0;

    window.scrollTo({ top: 0, behavior: "auto" });

    const tryScroll = () => {
      const element = document.getElementById(targetId);

      if (!element) {
        if (attempts < maxAttempts) {
          attempts += 1;
          timeoutId = window.setTimeout(tryScroll, 50);
        }
        return;
      }

      const top =
        element.getBoundingClientRect().top +
        window.scrollY -
        navbarHeight -
        offset;

      window.scrollTo({
        top,
        behavior: "smooth",
      });

      navigate("/", { replace: true });
    };

    rafId = window.requestAnimationFrame(() => {
      timeoutId = window.setTimeout(tryScroll, 60);
    });

    return () => {
      window.cancelAnimationFrame(rafId);
      window.clearTimeout(timeoutId);
    };
  }, [location.search, navigate]);

  return (
    <>
      <HeroSection />
      {/* <FeaturesSection /> */}
      <TrainerBenefitsSection />
      <TrainerJoinSection />
      <TrainersSection />
      <ProgramsSection />
      <DownloadCTASection />
      <TestimonialsSection />
    </>
  );
}
// 🔒